import isEmail from 'validator/lib/isEmail';

export default class InputValidationUtil {
    static isValidEmail(string) {
        return isEmail(string);
    }

    static isValidPhoneNumber(string) {
        return string.match("^[+\\-0-9(). ]+$") !== null;
    }
}



// WEBPACK FOOTER //
// ./src/utils/InputValidationUtil.js